import { useCallback, useRef, useState } from "react";

// Keeps a node's width current. Charts drawn from a one-off
// getBoundingClientRect() keep whatever width they happened to have: wrong
// after a window resize, and 0 while their screen is hidden — the dashboard
// stays mounted behind the comparison screen, and `display: none` measures as
// 0, which is how the trend panels came back blank.
//
// A callback ref rather than an effect: the nodes this measures only exist
// once an import finishes, so they attach on a later render.
export function useElementWidth() {
  const observerRef = useRef(null);
  const [width, setWidth] = useState(0);

  const ref = useCallback((node) => {
    observerRef.current?.disconnect();
    observerRef.current = null;
    if (!node) return;
    setWidth(node.getBoundingClientRect().width);
    if (typeof ResizeObserver === "undefined") return;
    observerRef.current = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    observerRef.current.observe(node);
  }, []);

  return [ref, width];
}
